
export const symptoms = [
    "Difficulty breathing, wheezing in the lungs, coughing",
    "Seasonal colds, allergic reactions",
    "Chronic and acute bronchitis, pneumonia",
    "COPD, bronchial asthma, pleurisy",
  ]

